<template>
  <container>
    <v-row>
      <v-col cols="12" md="7">
        <CategoriesTable />
      </v-col>
      <v-col cols="12" md="5">
        <LocalCategoriesTable />
      </v-col>
    </v-row>
  </container>
</template>

<script>
import CategoriesTable from "../components/CategoriesTable";
import LocalCategoriesTable from "../components/LocalCategoriesTable";

export default {
  name: "categories",
  components: {
    CategoriesTable,
    LocalCategoriesTable,
  },
  data: () => ({}),
};
</script>